import { Stack, Typography } from '@mui/material';
import React from 'react';

import { globalUtils } from '@/shared/duck';
import { muiPalette } from '@/shared/general-theme';

interface CellTextProps {
  title: string,
  description?: string;
  titleColor?: string
  titleWeight?: string | number;
}

const CellText: React.FC<CellTextProps> = ({
  title,
  description,
  titleColor = muiPalette.text?.primary,
  titleWeight = 400,
}) => {
  return (
    <Stack gap='0.13rem'>
      <Typography
        sx={{
          fontWeight: titleWeight,
          color: titleColor,
          fontSize: '0.875rem',
          lineHeight: '1.25rem',
        }}
      >
        {title}
      </Typography>

      {description && (
        <Typography
          variant={'caption'}
          sx={{
            color: muiPalette.text?.secondary,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
          }}
        >
          {globalUtils.sliceTextByLimit(description, true)}
        </Typography>
      )}
    </Stack>
  );
};

export default CellText;